import { useNuxtApp } from "#app";
const noop = {
  error: () => {
  },
  event: () => {
  }
};
export const useObservability = () => {
  const { $groundcover } = useNuxtApp();
  if ($groundcover) {
    return {
      error: (error, attributes) => {
        const err = error instanceof Error ? error : new Error(String(error));
        $groundcover.captureException(err, attributes);
      },
      event: (name, attributes) => {
        $groundcover.sendCustomEvent({
          event: name,
          attributes: attributes ?? {}
        });
      }
    };
  }
  return noop;
};
